import React from "react";

const Loading = props => {
  const {loading, className} = props;

  const classes = `spinner-border ${className || ""}`;

  return loading ? (
    <div className={"text-secondary " + classes} role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  ) : (
    <></>
  );
};

export default Loading;
